import { Injectable } from "@angular/core";
import { ApiRequestDispatcherService } from "apps-module/app/shared-library/services/api/api-request-dispatcher.service";
import { Observable } from "rxjs";

import { SearchFilterModel } from "../models/search-filter.model";
import { SearchResultModel } from "../models/search-result.model";

@Injectable()
export class SearchService {
    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService
    ) {
    }

    public search(searchParams: SearchFilterModel): Observable<SearchResultModel> {
        return this._requestDispatcher.post<SearchResultModel>("/api/pcg-trainings-search/examine/get-search-results", { ...searchParams });
    }
}
